









































import { Component, Vue } from "vue-property-decorator";

import Input from "@/components/Input.vue";
import { FormErrors } from "@/core/forms.interfaces";
import { entriesAdd } from "@/store/types";

@Component({
  components: {
    Input
  }
})
export default class AddEntry extends Vue {
  /**
   * A blank Entry form
   */
  private defaultForm = {
    diastolic: 0,
    pulse: 0,
    systolic: 0
  };

  /**
   * Live Entry form
   */
  form = {
    ...this.defaultForm
  };

  /**
   * Provides an error message when the Entry form has errors
   */
  get isFormInvalid(): FormErrors | undefined {
    const entry = { ...this.form };
    if (!entry.diastolic || !entry.pulse || !entry.systolic) {
      return {
        message: "Missing required fields."
      };
    }
    return undefined;
  }

  /**
   * Submits a new Entry to be saved to the user's `entries` collection
   */
  addEntry() {
    this.$store.dispatch({
      type: entriesAdd,
      entry: {
        ...this.form,
        dateTime: new Date().toISOString()
      }
    });
    this.form = { ...this.defaultForm };
  }
}
